module.exports = __webpack_public_path__ + "static/rainbow-only-mobile-64e34c0d8aa5060b26bf689533451294.png";